/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import orderAndPayDetailsComponent from './orderAndPay.component';

const orderAndPayDetailsModule = angular.module('tinaba.components.services.orderAndPay', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.orderAndPay', {
        url: '/orderAndPay',
        template: '<order-and-pay-details></order-and-pay-details>'
    });
})

.component('orderAndPayDetails', orderAndPayDetailsComponent);

export default orderAndPayDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/orderAndPay.js
 **/